import { useState } from 'react'

import { FullLogo, Logo } from '@/shared/ui'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import { Layout, Menu } from 'antd'
import clsx from 'clsx'

import { type MenuItem } from '../../router'
import './styles.scss'

const { Sider, Content } = Layout
export function getTabKey(key: number): React.Key {
  return key + 1
}

type MainLayoutProps = {
  selectedMenuKeys?: string[]
  menuItems: MenuItem[]
}
export function MainLayout({
  children,
  selectedMenuKeys,
  menuItems,
}: React.PropsWithChildren<MainLayoutProps>) {
  const [collapsed, setCollapsed] = useState(false)
  return (
    <Layout hasSider>
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onCollapse={(collapsed) => setCollapsed(collapsed)}
        width={270}
        collapsedWidth={60}
        className={clsx('siderStyle', { 'siderStyle--collapsed': collapsed })}
        theme="light"
      >
        {collapsed ? <Logo className="logo" /> : <FullLogo className="logo" />}
        <Menu
          className="menuStyle"
          selectedKeys={selectedMenuKeys}
          mode="inline"
          items={menuItems}
        />
      </Sider>
      <Layout className="layoutStyle">
        <Content className="contentStyle">{children}</Content>
      </Layout>
    </Layout>
  )
}
